export default {
      id: "classic-focus-usage",
      viewBox: "0 0 67.24 53.451",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#classic-focus",
      toString: function () {
        return this.url;
      }
    }